import { defineStore } from 'pinia';
import { api, ApiError } from '@/api';

export interface Me {
  id: string;
  email: string;
  name: string;
  role: 'employee' | 'finance' | 'admin';
}

export const useSession = defineStore('session', {
  state: () => ({
    me: null as Me | null,
    /** null until the first /api/me settles, so the UI can avoid flashing the login screen. */
    loaded: false,
  }),

  getters: {
    signedIn: s => s.me !== null,
    isAdmin: s => s.me?.role === 'admin',
    /** Finance and admin see everyone's requests and invoices, and decide them. */
    isFinance: s => s.me?.role === 'finance' || s.me?.role === 'admin',
  },

  actions: {
    /** A 401 here is the normal signed-out path, not an error worth surfacing. */
    async load(): Promise<void> {
      try {
        this.me = await api.get<Me>('/api/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) this.me = null;
        else throw err;
      } finally {
        this.loaded = true;
      }
    },

    async signOut(): Promise<void> {
      await api.post('/auth/logout');
      this.me = null;
      // Full reload so no view keeps stale data belonging to the signed-out user.
      window.location.assign('/');
    },
  },
});
